import { render, staticRenderFns } from "./MainSlider.vue?vue&type=template&id=4e56de80&scoped=true"
import script from "./MainSlider.vue?vue&type=script&lang=js"
export * from "./MainSlider.vue?vue&type=script&lang=js"
import style0 from "./MainSlider.vue?vue&type=style&index=0&id=4e56de80&prod&lang=scss&scoped=true"
import style1 from "./MainSlider.vue?vue&type=style&index=1&id=4e56de80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e56de80",
  null
  
)

export default component.exports